import { MakeWholeCallSpreadBps } from "@goodfill/domain-properties/src";
import Decimal from "decimal.js";
import React from "react";

interface Props {
  value: MakeWholeCallSpreadBps | null;
}

export const formatMakeWholeCall = (props: Props) =>
  props.value !== null
    ? `UST ${Number(props.value) >= 0 ? "+" : "-"} ${new Decimal(props.value).abs().toDecimalPlaces(3)}bps`
    : "";

export const MakeWholeCallComponent: React.FC<{ value: MakeWholeCallSpreadBps | null }> = (props) => {
  return <>{formatMakeWholeCall(props)}</>;
};
